import { createContext, ReactNode, use, useState } from 'react';

import { useCurrentDocument } from '../hooks/useDocument';

export const PageContext = createContext({
    pageKey: null,
    setPage: null,
});

export function usePageContext() {
    const context = use(PageContext);
    return context;
}

export function usePageKey() {
    const { pageKey } = usePageContext();
    return pageKey;
}

export function useSetPage() {
    const { setPage } = usePageContext();
    return setPage;
}

interface PageContextProviderProps {
    children?: ReactNode;
}

export function PageContextProvider({ children = null }: PageContextProviderProps) {
    const [page, setPage] = useState(null);
    const currentDocument = useCurrentDocument();
    const {
        id: documentId = null,
        type = null,
        metadata = null,
        slug = null,
    } = currentDocument || {};
    const { micromagNumber = null } = metadata || {};

    const { pageType = null, categories = null, section } = page || {};

    const pageKey =
        (micromagNumber !== null ? `micromag_${micromagNumber}` : null) ||
        (slug !== null ? `${type}_${slug}` : null) ||
        (documentId !== null ? `${type}_${documentId}` : null) ||
        (pageType !== null
            ? [
                  pageType,
                  section || (categories !== null && categories.length > 0 ? categories[0] : null),
              ]
                  .filter((it) => it !== null)
                  .join('_')
            : null) ||
        null;
    return (
        <PageContext
            value={{
                pageKey,
                setPage,
            }}
        >
            {children}
        </PageContext>
    );
}
